/**
 * Wraps a `key => createSelector(...)` factory so each distinct key keeps its OWN memoized selector,
 * cached in a Map. Unlike `memoizeOne(key => ...)` — which keeps a single slot and recomputes every
 * time the key changes — this stays memoized when several keys are read in the same render (e.g. two
 * document panes showing different documents), so the per-key selectors don't thrash each other.
 *
 * The public shape is identical to the memoizeOne idiom: call it with a key, get back a selector.
 *
 * @param {(key: string) => Function} factory Builds the selector for a key (typically `createSelector`)
 * @returns {(key: string) => Function}
 */
const createKeyedSelector = factory => {
  const cache = new Map();

  return key => {
    if (!cache.has(key)) {
      cache.set(key, factory(key));
    }

    return cache.get(key);
  };
};

export default createKeyedSelector;
